import { defineMessages } from 'react-intl';
// import Schema from '@plone/volto/components/manage/Blocks/Block/Schema';
import { subjectSchema } from './schema';
import Edit from './Edit';
import View from './View';
import iconSVG from './icons/head-title.svg';

defineMessages({
  subject: {
    id: 'Subject',
    defaultMessage: 'Subject',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.subject = {
    id: 'subject',
    title: 'Subject',
    group: 'text',
    icon: iconSVG,
    view: View,
    edit: Edit,
    schema: subjectSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    blockHasOwnFocusManagement: true,
    hide_alignment: false,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
